import styled from 'styled-components'

import { colors } from '../../../../shared/styles/colors'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 20px 20px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
export const Detalhes = styled.div`
  padding-left: 30px;
  padding-top: 30px;
  background-color: ${colors.white};
  border: 0px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`
export const TitleArea = styled.div`
  padding-bottom: 20px;
  color: ${colors.green};
  font-weight: bold;
`

export const TitleItem = styled.span`
  color: #000000;
  font-size: 16px;
  font-weight: 900;
  line-height: 140%;
  text-transform: capitalize;
`
export const SubtitleItem = styled.span`
  color: #999999;
  font-size: 14px;
  line-height: 140%;
`
